import { IconButton } from '@mui/material';
import { ReactNode } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaArrowLeftLightSvgIcon } from '../../assets/icons/svgs';
import { ROUTE_PATH_NAMES } from '../../routes/router/routePathNames';
import { colors } from '../../theme/colors';
import spacing, { isMobileScreen } from '../../theme/spacing';
import { fontSize } from '../../theme/typography';

interface TopMenuPageTitleProps {
  title: string;
  logoComponent?: ReactNode;
  showBackButton?: boolean;
  showDesktopBackButton?: boolean;
  fallbackPath?: string;
}

const TopMenuPageTitle = ({
  title,
  logoComponent,
  showBackButton,
  showDesktopBackButton,
  fallbackPath,
}: TopMenuPageTitleProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const shouldShowBackButton =
    showBackButton && (isMobileScreen || showDesktopBackButton);

  const handleBackPress = () => {
    if (location.key !== 'default') {
      navigate(-1);
    } else {
      navigate(fallbackPath ?? ROUTE_PATH_NAMES.SEARCH);
    }
  };

  if (logoComponent) {
    return (
      <div
        style={{
          display: 'inline-flex',
          alignItems: 'center',
        }}
      >
        {logoComponent}
      </div>
    );
  }

  return (
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
      }}
    >
      {shouldShowBackButton && (
        <IconButton
          onClick={handleBackPress}
          style={{
            padding: spacing.small,
            paddingLeft: 0,
            marginRight: spacing.small,
          }}
        >
          <FaArrowLeftLightSvgIcon
            size={fontSize['2xl']}
            fill={colors.textPrimary}
          />
        </IconButton>
      )}
      <div
        style={{
          display: 'inline-block',
          color: colors.textPrimary,
          fontSize: isMobileScreen ? fontSize.xl : fontSize['2xl'],
          fontWeight: 'bold',
        }}
      >
        {title}
      </div>
    </div>
  );
};

export default TopMenuPageTitle;
